import React, { useContext, useEffect, useRef, useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Importing Components and Pages
import NavBar from './components/NavBar';
import Home from './pages/Home';
import AllProducts from './pages/AllProducts';
import Sofa from './pages/Sofa';
import Chair from './pages/Chair';
import Table from './pages/Table';
import Registeration from './pages/Registeration';
import AboutUs from './pages/AboutUs';
import MyAccount from './pages/MyAccount';
import SingleProductPage from "./pages/SingleProductPage"
import ProductsPageLayout from "./pages/ProductsPageLayout"
import NotFound from './pages/NotFound';

// Importing The Context
import { SingleCategoryPageContextStart } from './Context/SingleCategoryPageContext';

export default function App() {

  const { categoryDetail } = useContext(SingleCategoryPageContextStart);
  const [getCategory, setGetCategory] = useState(localStorage.getItem("category"))

  useEffect(() => {
    setGetCategory(localStorage.getItem("category"));
  }, [categoryDetail]);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<NavBar />}>
            <Route index element={<Home />} />
            <Route path='all-products' element={<AllProducts />} />
            <Route path='sofa' element={<Sofa />} />
            <Route path='chair' element={<Chair />} />
            <Route path='table' element={<Table />} />
            <Route path='my-account' element={<MyAccount />} />
            <Route path='about-us' element={<AboutUs />} />
            <Route path='registration' element={<Registeration />} />
            <Route path="product" element={<SingleProductPage />} />
            <Route path="category" element={<ProductsPageLayout productCategory={`${getCategory}`} />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  )
}
